<template>
  <footer>
    <br><hr>
    <p>Developed by thigoap. |
      <a target="blank" href="https://github.com/thigoap">
      <i class="fab fa-github"></i></a>
    </p>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
  margin-top: auto;
}
</style>
